import email_validator from 'email-validator';
import bs58check from 'bs58check';
import bech32 from 'bech32';

const usernameRegex = /^[a-zA-Z0-9]{1,200}$/;
const passwordRegex = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}/;
export const usernameIsValid = (username) => usernameRegex.test(username);
export const passwordIsValid = (password) => passwordRegex.test(password);
export const emailIsValid = (address) => email_validator.validate(address);
export const walletIsValid = function (address) {
    try {
        const bcbytes = bs58check.decode(address);
        return bcbytes[0] === 60 || bcbytes[0] === 78;
    } catch (error) {
        // pass
    }
    try {
        const decoded = bech32.decode(address);
        return decoded.prefix === 'royale';
    } catch (error) {
        // pass
    }
    return false;
};



// WEBPACK FOOTER //
// /src/services/validation.js